export default function Users() {
    const users = [
      { name: "Amit Sharma", role: "Frontend Developer", img: "https://i.pravatar.cc/150?img=1" },
      { name: "Neha Singh", role: "HR Manager", img: "https://i.pravatar.cc/150?img=2" },
      { name: "Rahul Verma", role: "UI/UX Designer", img: "https://i.pravatar.cc/150?img=3" },
      { name: "Priya Patel", role: "Backend Developer", img: "https://i.pravatar.cc/150?img=4" },
      { name: "Varun Sahu", role: "QA Engineer", img: "https://i.pravatar.cc/150?img=5" },
      { name: "Meera Joshi", role: "Marketing Lead", img: "https://i.pravatar.cc/150?img=6" },
    ];
  
    return (
      <div className="p-6 w-full">
  
        {/* PAGE HEADER */}
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-semibold">Users</h1>
  
          <button className="bg-blue-600 text-white px-4 py-2 rounded-xl shadow hover:bg-blue-700">
            + Add New User
          </button>
        </div>
  
        {/* SEARCH & FILTERS */}
        <div className="flex items-center gap-4 mb-8">
  
          <input
            type="text"
            placeholder="Search employees..."
            className="px-4 py-2 rounded-xl bg-white shadow-sm border w-72 outline-none"
          />
  
          <select className="px-4 py-2 rounded-xl bg-white shadow-sm border outline-none">
            <option>All Departments</option>
            <option>Development</option>
            <option>Design</option>
            <option>HR</option>
            <option>Marketing</option>
          </select>
  
          <select className="px-4 py-2 rounded-xl bg-white shadow-sm border outline-none">
            <option>Status: All</option>
            <option>Active</option>
            <option>Inactive</option>
          </select>
        </div>
  
        {/* USERS GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
  
          {users.map((user, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-5 shadow-sm border hover:shadow-md transition"
            >
              {/* USER IMAGE */}
              <img
                src={user.img}
                alt={user.name}
                className="w-20 h-20 rounded-full border mx-auto"
              />
  
              {/* USER NAME */}
              <h2 className="text-lg font-semibold text-center mt-4">
                {user.name}
              </h2>
  
              {/* ROLE */}
              <p className="text-center text-gray-500 text-sm">
                {user.role}
              </p>
  
              {/* ACTION BUTTONS */}
              <div className="flex items-center justify-center gap-3 mt-4">
                <button className="px-4 py-2 rounded-xl bg-gray-100 border text-sm hover:bg-gray-200">
                  View
                </button>
                <button className="px-4 py-2 rounded-xl bg-blue-600 text-white text-sm hover:bg-blue-700">
                  Edit
                </button>
              </div>
            </div>
          ))}
  
        </div>
      </div>
    );
  }
  